<m-messages
  *ngIf="messagesCount()"
  [messages]="messages()"
  [escape]="false"></m-messages>
